import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import BreadCrumb from "src/Components/GlobalComponents/BreadCrumb";
import CategoriesBanners from "src/Components/PharmacyComponents/Admin/WebsiteManeges/CategoriesBanners";
import DoctorBannerSection from "src/Components/PharmacyComponents/Admin/WebsiteManeges/DoctorBannerSection";
import DoctorBannerSection09 from "src/Components/PharmacyComponents/Admin/WebsiteManeges/DoctorBannerSection09";
import HomecareServiceSection from "src/Components/PharmacyComponents/Admin/WebsiteManeges/HomecareServiceSection";
import MainBanner from "src/Components/PharmacyComponents/Admin/WebsiteManeges/MainBanner";
import PackageCategorySection from "src/Components/PharmacyComponents/Admin/WebsiteManeges/PackageCategorySection";
import ProductcategorySection from "src/Components/PharmacyComponents/Admin/WebsiteManeges/ProductcategorySection";
import PromotionalBanner from "src/Components/PharmacyComponents/Admin/WebsiteManeges/PromotionalBanner";
import TopBrands from "src/Components/PharmacyComponents/Admin/WebsiteManeges/TopBrands";
import TopCategories from "src/Components/PharmacyComponents/Admin/WebsiteManeges/TopCategories";
import httpRequest from "src/helpers/httpRequest";
import { IHomePageInterface, IMainCategory } from "src/types/GlobalInterfaces";

const HomePage: React.FC = () => {
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [data, setData] = useState<IHomePageInterface | null>(null);
  const [getLoader, setGetLoader] = useState(false);
  const [allCategories, setAllCategories] = useState<
    { value: string; label: string }[]
  >([]);
  const [allHomecareCategories, setAllHomecareCategories] = useState<
    { value: string; label: string }[]
  >([]);
  const [homecareLoader, setHomecareLoader] = useState(false);

  const fetch = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<{ documents: IHomePageInterface }>({
      path: "/website-manage/main/adminSide",
    });
    if (res) {
      setData(res?.documents);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const fetchAllHomecareCategories = async () => {
    setHomecareLoader(true);
    const { res, err } = await httpRequest<{ documents: IMainCategory[] }>({
      path: "/homecare-category/all-paginated?limit=1000",
    });
    if (res) {
      const arr =
        res?.documents?.map((v) => ({
          value: v?._id,
          label: v?.categoryName,
        })) || [];
      setAllHomecareCategories(arr);
    } else {
      toast(err, { type: "error" });
    }
    setHomecareLoader(false);
  };

  const fetchAllCategories = async () => {
    setGetLoader(true);
    const { res, err } = await httpRequest<{ documents: IMainCategory[] }>({
      path: "/main-category/getAllMainCategory",
    });
    if (res) {
      const arr =
        res?.documents?.map((v) => ({
          value: v?._id,
          label: v?.categoryName,
        })) || [];
      setAllCategories(arr);
    } else {
      toast(err, { type: "error" });
    }
    setGetLoader(false);
  };

  useEffect(() => {
    fetch();
    fetchAllCategories();
    fetchAllHomecareCategories();
  }, []);

  return (
    <>
      <BreadCrumb
        current="Website Manage"
        previous="dashboard"
        navigateUrl="/admin"
      />
      <div className="table-container flex flex-col gap-5">
        {data && (
          <>
            <MainBanner allBanner={data?.sectionOne} setData={setData} />
            <TopCategories
              data={data?.sectionTwo}
              allCategories={allCategories}
              getLoader={getLoader}
            />
            <CategoriesBanners
              allCategories={allCategories}
              getLoader={getLoader}
              sectionTitle="Section 03"
              apiEndPoint="/website-manage/section-three"
              data={data?.sectionThree}
              allList={[]}
              setData={setData}
              keys="sectionThree"
              mainHeading="Pharmacy Banner"
            />
            <ProductcategorySection
              allCategories={allCategories}
              data={{
                heading: data?.sectionFour?.heading || "",
                products: data?.sectionFour?.products || [],
              }}
              setData={setData}
            />
            <CategoriesBanners
              allCategories={allHomecareCategories.map(tm => ({
                ...tm,
                value: tm?.value || "",
                label: tm?.label || "",
              }))}
              getLoader={homecareLoader}
              sectionTitle="Section 05"
              apiEndPoint="/website-manage/section-five"
              data={{
                banner: data?.sectionFive?.homeCareBanner || "",
                mainCategoryId: data?.sectionFive?.homeCareCategoryId || "",
              }}
              allList={[]}
              setData={setData}
              keys="sectionFive"
              mainHeading="Homecare Banner"
              serviceTitle="Select Homecare Category"
              isHomeCare={true}
            />
            <HomecareServiceSection
              allCategories={allHomecareCategories.map(tm => ({
                ...tm,
                value: tm?.value || "",
                label: tm?.label || "",
              }))}
              allMainCategory={allCategories}
              setData={setData}
              data={{
                heading: data?.sectionSix?.heading || "",
                services: data?.sectionSix?.services || [],
              }}
            />
            <DoctorBannerSection data={data?.sectionSeven} setData={setData} />
            <PackageCategorySection
              allCategories={allCategories}
              setData={setData}
              data={data?.documentsEight}
            />
            <DoctorBannerSection09 data={data?.documentsNine} setData={setData} />
          </>
        )}
      </div>
    </>
  );
};

export default HomePage;
